export const defaultPrompts = [
  {
    value: 'conversationModels.defaultPrompts.translateFromVaultValue',
    text: 'conversationModels.defaultPrompts.translateFromVaultText',
  },
  {
    value: 'conversationModels.defaultPrompts.helpMeExplainValue',
    text: 'conversationModels.defaultPrompts.helpMeExplainText',
  },
  {
    value: 'conversationModels.defaultPrompts.writeABannerForMeValue',
    text: 'conversationModels.defaultPrompts.writeABannerForMeText',
  },
  {
    value: 'conversationModels.defaultPrompts.writeABlogPostValue',
    text: 'conversationModels.defaultPrompts.writeABlogPostText',
  },
];

export const scopedConversationPrompts = [
  {
    value: 'conversationModels.scopedConversationPrompts.helpMeSupportAClaimValue',
    text: 'conversationModels.scopedConversationPrompts.helpMeSupportAClaimText',
  },
  {
    value: 'conversationModels.scopedConversationPrompts.findClaimsValue',
    text: 'conversationModels.scopedConversationPrompts.findClaimsText',
  },
  {
    value: 'conversationModels.scopedConversationPrompts.createATableOfContentsValue',
    text: 'conversationModels.scopedConversationPrompts.createATableOfContentsText',
  },
  {
    value: 'conversationModels.scopedConversationPrompts.translateFromVaultValue',
    text: 'conversationModels.scopedConversationPrompts.translateFromVaultText',
  },
  {
    value: 'conversationModels.scopedConversationPrompts.helpMeExplainValue',
    text: 'conversationModels.scopedConversationPrompts.helpMeExplainText',
  },
  {
    value: 'conversationModels.scopedConversationPrompts.writeABannerForMeValue',
    text: 'conversationModels.scopedConversationPrompts.writeABannerForMeText',
  },
  {
    value: 'conversationModels.scopedConversationPrompts.writeABlogPostValue',
    text: 'conversationModels.scopedConversationPrompts.writeABlogPostText',
  },
];

export const ERROR_MESSAGE = `I'm sorry, something went wrong when handling your request.\n\n Please try again, or <a href="https://support.arcane.anthill.technology" target="_blank" style="text-decoration: underline;"> click here</a> to report this problem.`;

export const messageType = {
  message: 'MESSAGE',
  error: 'ERROR',
  context: 'CONTEXT_MESSAGE',
  system: 'SYSTEM_MESSAGE',
};

export const Role = {
  user: 'User',
  chatbot: 'ArcaneAI',
};

export const INITIAL_CONVERSATION = {
  conversationId: '',
  title: 'New conversation',
  messages: [],
  timestamp: '',
};

export const EMPTY_CHAT = {
  messageId: '',
  message: '',
  role: Role.chatbot,
  type: messageType.message,
  data: [],
  chunks: [], // scopedMessage: false,
};

export const WELCOME_AUTHORING_MESSAGE = {
  messageId: '',
  message:
    "Hi, I am your assistant, here to help you create you first email. Please provide a prompt or a brief description of what you'd like your email to be about.",
  role: Role.chatbot,
  type: messageType.message,
  data: [],
  chunks: [],
};

export const RESPONSE_TYPE = {
  endMessage: 'END_OF_MESSAGE',
  messages: 'MESSAGE',
  data: 'DATA',
  systemMessages: 'SYSTEM',
  error: 'ERROR',
  layoutGeneration: 'LAYOUT_GENERATION',
  endMessageLayoutGeneration: 'END_OF_MESSAGE_GENERATE_LAYOUTS',
};

export const queryType = {
  sentiment: 'LIKE_DISLIKE',
  search: 'SEARCH_QUERY',
  authoringQuery: 'AUTHORING_QUERY',
};

export const DOCUMENT_METADATA = {
  product_name: 'Product',
  country: 'Country',
  status: 'Status',
};

export const CURRENT_DIALOG = {
  favorites_panel: 'FavoritesPanelDialog',
  document_panel: 'DocumentPanelDialog',
  notifications_panel: 'NotificationsPanelDialog',
  collections_panel: 'CollectionsPanelDialog',
};

export const SCOPED_MESSAGE = {
  scoped: true,
  collection: {},
};

export const DEFAULT_COLLECTION = {
  collectionId: 'vault',
  collectionName: 'Vault',
};

export const CONVERSATION_CHANNEL = {
  assist_response: 'conversations-response',
  naming: 'naming-response',
  authoring_response: 'authoring-response',
};

export const LAYOUT_CHANNEL = {
  layout_generation: 'layout-generation',
};

export const CHUNK_TYPE = {
  TEXT: 'text',
  TOOL_USE: 'tool_use',
  RESEARCH: 'research',
};

export const isSuggestedCategory = {
  id: '1',
  title: 'Suggested',
};
